module.exports = __webpack_public_path__ + "static/media/CO2.248b2278.png";